import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { DocumentChanged } from 'api/notifications/meta';
import { InlineLink } from '../basics';
import { Causer } from './causer';

export const DocumentChangedView: FC<{ meta: DocumentChanged }> = ({
  meta: { by, title },
}) => (
  <FormattedMessage
    id="notifications.messages.document_changed"
    values={{
      causer: <Causer user={by} />,
      title: <InlineLink title={title} />,
    }}
  />
);
